/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */

/**
 * Card types issued through PPS, as they appear in PPS routes and in the
 * `card_type` discriminator of card listings.
 *
 * Highnote issues `vc`, `pc` (Virtual and Physical Card, receive every
 * payout kind) and `ec`, `pec` (Expense Cards, admin-funded, never receive a
 * payout). Stripe issues `vstc`, `pstc` (Stipend Cards, receive stipends and
 * micropayments only) and `vspc`, `pspc` (Spend Cards, pay study costs from
 * the sponsor's pool, never receive a payout). Only `vc`, `pc`, `vstc` and
 * `pstc` may be the Default Payment Account. Expense Cards and Spend Cards
 * list with a `null` balance, which means hidden. The wire values are PPS's
 * and are not renamed here.
 */
export type CardPaymentMethodType =
  (typeof CardPaymentMethodType)[keyof typeof CardPaymentMethodType];

export const CardPaymentMethodType = {
  vc: "vc",
  pc: "pc",
  ec: "ec",
  pec: "pec",
  vstc: "vstc",
  pstc: "pstc",
  vspc: "vspc",
  pspc: "pspc",
} as const;
